const pt = {
  approval: 'Aprovação',
  summary: 'Resumo',
  general: 'Geral',
  summaryTitle: 'Resumo do pedido',
  summaryDescription: 'Confira os dados principais antes de confirmar o pedido.',
  createdAt: 'Criado em',
  smartsellNumber: 'Número SmartSell',
  document: 'Documento',
  commercialConditions: 'Condições comerciais',
  deliveryBilling: 'Entrega e faturamento',
  phone: 'Telefone',
  email: 'E-mail',
  creditLimit: 'Limite de Cre.',
  grossShort: 'Total Bru.',
  netShort: 'Total Liq.',
  productsCount: 'produto(s)',
  unitsCount: 'unidade(s)',
  summaryQuantity: 'Qtd.',
  generalDiscountInput: 'Desconto geral (%)',
  updatedAt: 'Atualizado em',
  customerCode: 'Código',
  erpNumber: 'Número ERP',
  financialSummary: 'Resumo financeiro',
  subtotal: 'Subtotal de tabela',
  orderTotal: 'Total do pedido',
  discountItems: 'Desconto dos itens',
  discountGeneral: 'Desconto geral',
  discountTotal: 'Desconto total',
  afterDiscount: 'Resultado',
  orderItems: 'Itens do pedido',
  orderMetrics: 'Totais do pedido',
  totalQuantity: 'Quantidade total',
  discount: 'Desconto',
  netUnitPrice: 'Preço líquido unitário',
  lineTotal: 'Total',
  baseUnitPrice: 'Preço informado',
  recordedSaleValue: 'Valor de venda registrado',
  productCode: 'Código',
  itemDiscountShort: 'no item',
  items: 'Itens',
  commercial: 'Comercial',
  delivery: 'Entrega',
  navigation: 'Seções do pedido',
  order: 'Pedido',
  budget: 'Orçamento',
  approved: 'Liberado',
  cancelled: 'Cancelado',
  pending: 'Aguardando liberação',
  unknown: 'Não informado',
  exported: 'Exportado para o ERP',
  exportError: 'Erro na exportação',
  notExported: 'Não exportado',
  customer: 'Cliente',
  seller: 'Vendedor',
  company: 'Empresa',
  channel: 'Canal do cliente',
  total: 'Valor líquido',
  gross: 'Valor bruto',
  recordedItems: 'Itens registrados',
  weight: 'Peso do pedido',
  identification: 'Identificação do pedido',
  orderDate: 'Data do pedido',
  deviceNumber: 'Número local',
  parentOrder: 'Pedido de origem',
  purchaseOrder: 'Ordem de compra',
  orderType: 'Tipo de pedido',
  payment: 'Pagamento',
  paymentMethod: 'Forma de pagamento',
  paymentCondition: 'Condição de pagamento',
  priceTable: 'Tabela de preço',
  promotion: 'Promoção (código)',
  discount1: 'Desconto 1',
  discount2: 'Desconto 2',
  discount3: 'Desconto 3',
  commission: 'Comissão',
  profitability: 'Rentabilidade',
  values: 'Valores complementares',
  valuesHint: 'Valores do pedido registrados no SmartSell. Não são recalculados nesta consulta.',
  freightValue: 'Valor do frete',
  unloadingValue: 'Valor de descarga',
  partial: 'Aceita pedido parcial',
  yes: 'Sim',
  no: 'Não',
  search: 'Código, descrição ou código de barras',
  product: 'Produto',
  packaging: 'Embalagem',
  quantity: 'Quantidade',
  bonus: 'Bonificação',
  unitPrice: 'Preço unitário',
  saleValue: 'Valor de venda',
  itemDetails: 'Detalhes do item',
  noItems: 'Nenhum item registrado.',
  unavailableItems: 'Os itens não foram disponibilizados nesta consulta.',
  noResults: 'Nenhum item corresponde à busca.',
  itemsHint:
    'A consulta atual identifica os produtos pelo código. Valores e quantidades abaixo são os registrados no pedido.',
  balance: 'Saldo',
  tablePrice: 'Preço de tabela',
  surcharge: 'Acréscimo',
  tax: 'ICMS ST',
  itemFreight: 'Frete do item',
  cfop: 'CFOP',
  multiple: 'Múltiplo',
  priceApproval: 'Validação de preço',
  notes: 'Observações',
  note1: 'Observação 1',
  note2: 'Observação 2',
  complement1: 'Complemento 1',
  complement2: 'Complemento 2',
  noNotes: 'Nenhuma observação registrada.',
  logistics: 'Logística',
  billingUnit: 'Unidade de faturamento',
  state: 'UF',
  deliveryDate: 'Data de entrega',
  billingDate: 'Data de faturamento',
  carrier: 'Transportador (código)',
  address: 'Endereço de entrega (código)',
  destination: 'Cliente destinatário (código)',
  freightType: 'Tipo de frete',
  deliveryForm: 'Forma de entrega',
  freightName: 'Nome do frete (código)',
  milestones: 'Datas operacionais',
  emission: 'Emissão',
  cutoff: 'Corte',
  load: 'Carga',
  departure: 'Saída',
  checkOk: 'Aprovado',
  checkPending: 'Não aprovado',
  integration: 'Integração com o ERP',
  integrationMessage: 'Mensagem da integração',
};

const en: Record<keyof typeof pt, string> = {
  approval: 'Approval',
  summary: 'Overview',
  general: 'General',
  summaryTitle: 'Order summary',
  summaryDescription: 'Review the main details before confirming the order.',
  createdAt: 'Created at',
  smartsellNumber: 'SmartSell number',
  document: 'Document',
  commercialConditions: 'Commercial conditions',
  deliveryBilling: 'Delivery and billing',
  phone: 'Phone',
  email: 'Email',
  creditLimit: 'Credit lim.',
  grossShort: 'Gross total',
  netShort: 'Net total',
  productsCount: 'product(s)',
  unitsCount: 'unit(s)',
  summaryQuantity: 'Qty.',
  generalDiscountInput: 'General discount (%)',
  updatedAt: 'Updated at',
  customerCode: 'Code',
  erpNumber: 'ERP number',
  financialSummary: 'Financial summary',
  subtotal: 'Table subtotal',
  orderTotal: 'Order total',
  discountItems: 'Item discounts',
  discountGeneral: 'General discount',
  discountTotal: 'Total discount',
  afterDiscount: 'Result',
  orderItems: 'Order items',
  orderMetrics: 'Order totals',
  totalQuantity: 'Total quantity',
  discount: 'Discount',
  netUnitPrice: 'Net unit price',
  lineTotal: 'Line total',
  baseUnitPrice: 'Entered price',
  recordedSaleValue: 'Recorded sale amount',
  productCode: 'Code',
  itemDiscountShort: 'on item',
  items: 'Items',
  commercial: 'Commercial',
  delivery: 'Delivery',
  navigation: 'Order sections',
  order: 'Order',
  budget: 'Quotation',
  approved: 'Released',
  cancelled: 'Cancelled',
  pending: 'Awaiting release',
  unknown: 'Not provided',
  exported: 'Exported to ERP',
  exportError: 'Export error',
  notExported: 'Not exported',
  customer: 'Customer',
  seller: 'Seller',
  company: 'Company',
  channel: 'Customer channel',
  total: 'Net amount',
  gross: 'Gross amount',
  recordedItems: 'Recorded items',
  weight: 'Order weight',
  identification: 'Order identification',
  orderDate: 'Order date',
  deviceNumber: 'Local number',
  parentOrder: 'Source order',
  purchaseOrder: 'Purchase order',
  orderType: 'Order type',
  payment: 'Payment',
  paymentMethod: 'Payment method',
  paymentCondition: 'Payment terms',
  priceTable: 'Price table',
  promotion: 'Promotion (code)',
  discount1: 'Discount 1',
  discount2: 'Discount 2',
  discount3: 'Discount 3',
  commission: 'Commission',
  profitability: 'Profitability',
  values: 'Additional amounts',
  valuesHint: 'Order amounts recorded in SmartSell. They are not recalculated in this view.',
  freightValue: 'Freight amount',
  unloadingValue: 'Unloading amount',
  partial: 'Accepts partial order',
  yes: 'Yes',
  no: 'No',
  search: 'Code, description or barcode',
  product: 'Product',
  packaging: 'Packaging',
  quantity: 'Quantity',
  bonus: 'Bonus quantity',
  unitPrice: 'Unit price',
  saleValue: 'Sale amount',
  itemDetails: 'Item details',
  noItems: 'No recorded items.',
  unavailableItems: 'Items were not provided in this response.',
  noResults: 'No items match your search.',
  itemsHint:
    'This view identifies products by code. Amounts and quantities are those recorded in the order.',
  balance: 'Balance',
  tablePrice: 'Table price',
  surcharge: 'Surcharge',
  tax: 'ICMS ST',
  itemFreight: 'Item freight',
  cfop: 'CFOP',
  multiple: 'Multiple',
  priceApproval: 'Price validation',
  notes: 'Notes',
  note1: 'Note 1',
  note2: 'Note 2',
  complement1: 'Additional information 1',
  complement2: 'Additional information 2',
  noNotes: 'No recorded notes.',
  logistics: 'Logistics',
  billingUnit: 'Billing unit',
  state: 'State',
  deliveryDate: 'Delivery date',
  billingDate: 'Billing date',
  carrier: 'Carrier (code)',
  address: 'Delivery address (code)',
  destination: 'Recipient customer (code)',
  freightType: 'Freight type',
  deliveryForm: 'Delivery method',
  freightName: 'Freight name (code)',
  milestones: 'Operational dates',
  emission: 'Issue',
  cutoff: 'Cutoff',
  load: 'Loading',
  departure: 'Departure',
  checkOk: 'Approved',
  checkPending: 'Not approved',
  integration: 'ERP integration',
  integrationMessage: 'Integration message',
};

export type Label = keyof typeof pt;
export type Translate = (key: Label) => string;
export const messages = { pt, en };
